import React, { useEffect, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label, { DisplayLabel } from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Float from "../ui/Float";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { bm_date, drawNote, drawPOSStatus } from "../utils/Utils";

export default function OrdersDetails(props) {

    const { selected = {}, setSelected = () => { }, items = [], setItems = () => { }, selectedItem = {}, setSelectedItem = () => { } } = props;
    const [data, setData] = useState({});

  
    return (
        <div className="pos-card" style={{"height" : "260px", "overflow" : "hidden"}}>

           <pre><small>{JSON.stringify(selected, null, 2)}</small></pre>
           
        </div>
    )
}